import React from 'react';

const CustomAlert = ({ message, options, style, close }) => {
    return (
        <div className="custom-alert">
            {options.type === 'info' && <span className="custom-alert__icon info"></span>}
            {options.type === 'success' && <span className="custom-alert__icon success"></span>}
            {options.type === 'error' && <span className="custom-alert__icon error"></span>}
            <span className="custom-alert__message">{message}</span>
            <button className="custom-alert__close" onClick={close}></button>
        </div>
    );
};

export default CustomAlert;
